/**
 * @file MessageViewModal.js
 * @description A specific style of modal tailored to HR admins.
 */

import PropTypes from 'prop-types';
import style from './modals.module.scss';
import Spinner from '../spinners/Spinner';
import RichTextContent from '../RichTextContent';
import { getText } from '../../../i18n';

const MessageViewModal = ({ onHide, title, subtitle, text }) => {
    return (
        <div className={`${style.container} modal-backdrop`}>
            <div
                className="modal fade show display-block"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div
                    className={`modal-dialog modal-xl modal-dialog-centered ${style.modalSizing}`}
                >
                    <div className={`modal-content ${style.modalContent}`}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <h5 className="page-title">{title}</h5>

                            <h5 className="page-title ing-text">
                                {subtitle}
                                <span
                                    type="button"
                                    onClick={onHide}
                                    className="ing-text-buttons mx-3"
                                >
                                    <i className="bi bi-x me-2" />
                                    {getText('msg_bbfa773e5a63')}
                                </span>
                            </h5>
                        </div>

                        <hr />
                        <br />

                        <RichTextContent content={text || ''} />
                    </div>
                </div>
            </div>
        </div>
    );
};

MessageViewModal.propTypes = {
    onHide: PropTypes.func.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string.isRequired,
};

export default MessageViewModal;
